import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { Card, Empty, Page } from '../components/ui.jsx';

interface Notif {
  id: string;
  kind: string;
  title: string;
  body: string | null;
  data: string | null;
  readAt: number | null;
  createdAt: number;
}

export function NotificationsPage() {
  const qc = useQueryClient();
  const q = useQuery({
    queryKey: ['notifications'],
    queryFn: () => api<{ notifications: Notif[] }>('/api/v1/notifications'),
    refetchInterval: 30_000,
  });
  const mark = useMutation({
    mutationFn: (id: string) => api(`/api/v1/notifications/${id}/read`, { method: 'POST', body: {} }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['notifications'] }),
  });

  return (
    <Page title="Notifications">
      {q.isLoading ? <Empty>Loading…</Empty>
      : !q.data?.notifications.length ? <Empty>Nothing yet.</Empty>
      : q.data.notifications.map((n) => (
          <Card key={n.id} className={`mb-2 ${n.readAt ? 'opacity-60' : ''}`}>
            <div className="flex items-start justify-between">
              <div>
                <div className="text-sm font-medium">{n.title}</div>
                {n.body && <div className="text-sm text-slate-500 mt-1">{n.body}</div>}
                <div className="text-[10px] text-slate-400 mt-2">
                  {new Date(n.createdAt).toLocaleString()} · {n.kind}
                </div>
              </div>
              {!n.readAt && (
                <button className="text-xs underline decoration-dotted" onClick={() => mark.mutate(n.id)}>
                  Mark read
                </button>
              )}
            </div>
          </Card>
        ))}
    </Page>
  );
}
